<ng-container *transloco="let t;">
      <div class="mb-50">
        <div class="detailFirstColumn mb-50">
          <ng-container *ngIf="isPrivate; else shareableLink">
            <label class="col-form-label p-0">{{ t('Get shareable link text for details (Documents Section) - Get shareable link') }}</label>
          </ng-container>
          <ng-template #shareableLink>
            <small placement="auto" container="body"
                   ngbTooltip="Link Copied!"
                   [closeDelay]="1"
                   triggers="manual"
                   #tooltip="ngbTooltip">
              <a class="text-primary" (click)="copyDocUrl()">
                {{ t('Get shareable link text for details (Documents Section) - Get shareable link') }}
              </a>
            </small>
          </ng-template>
        </div>
        <div class="document-right-sidebar-get-link">
          <p class="mb-0 font-small-3">
            {{ t('Link text (Documents Section) - The link is') }}
            <a *ngIf="canEdit; else readonlyVisibility" class="text-primary" (click)="updateVisibility()">
              {{ t(visibilityText) }}
            </a>
            <ng-template #readonlyVisibility>
              <span class="text-muted">{{ t(visibilityText) }}</span>
            </ng-template>
          </p>
        </div>
      </div>
    </ng-container>